// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__rCUKP","actionsCol":"EnrolledClinics_actionsCol__3L9vB"};